<template>
  <div
    v-if="title"
    class="c-social-media l-flex l-flex--column l-flex--align-start u-margin-bottom-medium"
  >
    <h2 class="c-social-media__title t-heading-7 u-margin-bottom-small">
      {{ title }}
    </h2>
    <div class="l-flex">
      <div class="c-social-media__platform">
        <facebook-icon-link
          href="http://www.facebook.com/EnsoRings"
        />
      </div>
      <div class="c-social-media__platform">
        <twitter-icon-link
          href="http://www.twitter.com/EnsoRings"
        />
      </div>
      <div class="c-social-media__platform">
        <instagram-icon-link
          href="http://www.instagram.com/EnsoRings"
        />
      </div>
      <div class="c-social-media__platform">
        <pinterest-icon-link
          href="http://www.pinterest.com/EnsoRings"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InstagramIconLink from './InstagramIconLink'
import PinterestIconLink from './PinterestIconLink'
import FacebookIconLink from './FacebookIconLink'
import TwitterIconLink from './TwitterIconLink'
export default {
  name: "Social",
  components: {
    PinterestIconLink,
    InstagramIconLink,
    FacebookIconLink,
    TwitterIconLink,
  },
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.c-social-media {
  display: inline-block;
  &__title {
    text-transform: uppercase;
  }
  &__platform {
    &:not(:last-child) {
      margin-right: rem(10px);
    }
  }

}

</style>
